import React, { useContext } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { Context } from '@components/Context';
import { getPriceText } from '@utils/price';
import Colors from './Colors';

interface PriceTextProps {
  currencySymbol?: string;
  price: string | number;
  includePlusSign?: boolean;
  priceSuffix?: string;
  color?: string;
}

const PriceText: React.FC<PriceTextProps> = ({ currencySymbol, price, includePlusSign = false, priceSuffix, color }) => {
  const { state } = useContext(Context);
  const { currency, country } = state;
  const { t } = useTranslation();

  const numericPrice = typeof price === 'number' ? price : parseFloat(price);
  let formattedPrice = getPriceText(numericPrice, country, currency, t, false, false).fullString;

  if (currencySymbol) {
    formattedPrice = formattedPrice.replace(currency.symbol, currencySymbol);
  }
  if (priceSuffix) {
    formattedPrice += priceSuffix;
  }

  return (
    <StyledPrice $color={color} data-testid="price-text-display" data-value={formattedPrice}>
      {includePlusSign ? '+' : ''}
      {formattedPrice}
    </StyledPrice>
  );
};

export default PriceText;

const StyledPrice = styled.span<{ $color?: string }>`
  font-family: 'BrownStd';
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: ${({ $color }) => $color || Colors.navyBlue};
  white-space: nowrap;
`;
